module.exports = __webpack_public_path__ + "e04013e9a5396c61942b0b5996a8bd97.png";